import { createAsyncThunk } from "@reduxjs/toolkit";
import { MarathonsAPI } from "api/api/marathonsApi/marathonsApi";
import {
  GetMarathonsParams,
  GetMarathonsResponse,
} from "api/api/marathonsApi/types";
import axios from "axios";

export const getMarathons = createAsyncThunk<
  GetMarathonsResponse,
  GetMarathonsParams
>("marathons/getMarathons", async (params, { rejectWithValue }) => {
  try {
    const data = await MarathonsAPI.getMarathons(params);
    return data;
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      console.error("Error while getting marathons", error?.response?.data);
      return rejectWithValue(error?.response?.data || "Unknown error");
    } else {
      console.error("Error while getting marathons", error);
      return rejectWithValue(
        "Что-то пошло не так... Попробуйте обновить страницу"
      );
    }
  }
});
